import { Box, Button, Paper, TextField, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import Headers from "../../components/Headers";
import { useState, useRef } from "react";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useMessageStore } from "../../Utils/Store";
import * as XLSX from "xlsx";
import "./index.css";
import axios from "axios";
import Snackbar from "../../components/Snackbar/Snackbar";
import { useNavigate } from "react-router-dom";

const MultiSend = ({ isLogin, onMessageSent, onMessageFailed }) => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [status, setStatus] = useState(false);
  const [message, setMessage] = useState([]);
  const [snackbarRef, setSnackbarRef] = useState("");
  const [tags, setTags] = useState([]);
  const inputRef = useRef();
  const navigate = useNavigate();

  const numberInput = useMessageStore((state) => state.numberInput);
  const setNumInput = useMessageStore((state) => state.setNumInput);

  const textInput = useMessageStore((state) => state.textInput);
  const setTextInput = useMessageStore((state) => state.setTextInput);

  const handleFile = async (e) => {
    const file = e.target.files[0];
    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data);
    const worksheet = workbook.Sheets[workbook.SheetNames[0]];
    const jsonDATA = XLSX.utils.sheet_to_json(worksheet);

    let myNumbers = "";

    for (var i = 0; i < jsonDATA.length; i++) {
      myNumbers += jsonDATA[i].number + ",";
    }
    const result = myNumbers.substring(0, myNumbers.length - 1);

    let newNumber = result.split(",");
    setNumInput(result);
    setTags(newNumber);

    console.log(newNumber);
  };

  const removeTag = (index) => {
    setTags(tags.filter((el, i) => i !== index));
    console.log(tags);
  };

  const handlePost = async (e) => {
    e.preventDefault();
    if (numberInput === "" || textInput === "") {
      setStatus(true);
      onMessageFailed();
    } else {
      try {
        const response = await axios.post(process.env.REACT_APP_SEND_SMS, {
          phone_number: numberInput,
          message_content: textInput,
        });
        console.log(response);
        setStatus(true);
        await saveToDb();
      } catch (err) {
        console.log(err);
      }
    }
  };

  // const sendSms = async (token) => {
  //   function sendIt(arrayNew) {
  //     let finalNumbers = "";
  //     finalNumbers += JSON.stringify(arrayNew);
  //     const datasms = {
  //       destination: finalNumbers,
  //       text: textInput,
  //     };
  //     // console.log(finalNumbers);
  //     setMessage([...message, datasms]);
  //     axios
  //       .post("/sms", datasms, {
  //         headers: { Authorization: `Bearer ${token}` },
  //       })
  //       .then((response) => {
  //         setStatus(true);
  //         setSnackbarRef("success");
  //       })
  //       .catch((err) => console.log(err));
  //   }

  //   const chunkSize = 5;

  //   const chunkedResult = tags.reduce((resultArray, item, index) => {
  //     const chunkIndex = Math.floor(index / chunkSize);
  //     if (!resultArray[chunkIndex]) {
  //       resultArray[chunkIndex] = [];
  //     }
  //     resultArray[chunkIndex].push(item);
  //     return resultArray;
  //   }, []);

  //   let i = 0;
  //   (function loopIt(i) {
  //     setTimeout(() => {
  //       sendIt(chunkedResult[i]);
  //       if (i < chunkedResult.length - 1) return loopIt(i + 1);
  //       saveToDb();
  //     }, 3000);
  //   })(i);
  // };

  const saveToDb = async () => {
    try {
      const config = {
        method: "post",
        url: process.env.REACT_APP_SMS_TO_DB,
        headers: { "Content-Type": "application/json" },
        data: JSON.stringify({
          phone_number: numberInput,
          message: textInput,
          user_id: isLogin.id,
        }),
      };

      const response = await axios(config);
      setTags([]);
      setNumInput("");
      setTextInput("");
      inputRef.current.value = "";
      setStatus(true);
      onMessageSent();
      navigate("/sent");
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <Box m="20px">
      <Paper
        elevation={0}
        sx={{ borderRadius: "10px", background: colors.primary[400] }}
      >
        <Headers title="Multiple Send" />
      </Paper>
      <Paper
        elevation={0}
        sx={{
          borderRadius: "10px",
          padding: "10px",
          background: colors.primary[400],
        }}
      >
        <Box
          display="grid"
          gap="30px"
          height="60vh"
          gridTemplateColumns="repeat(3, 1fr)"
          sx={{
            "& > div": {
              gridColumn: isNonMobile ? undefined : "span 3",
            },
          }}
        >
          <Box
            gridColumn="span 2"
            backgroundColor={colors.primary[400]}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <input
              accept=".xlsx, .xls"
              required
              onChange={handleFile}
              type="file"
              id="fileControl"
              ref={inputRef}
            />
          </Box>
          <Box
            gridColumn="span 3"
            backgroundColor={colors.primary[400]}
            display="flex"
            alignItems="center"
            justifyContent="center"
            height="30vh"
          >
            <TextField
              fullWidth
              variant="filled"
              type="text"
              label="Mobile Number"
              value={numberInput}
              onChange={(e) => setNumInput(e.target.value)}
              name="mobilenumber"
              sx={{ display: "none" }}
            />
            <div className="messaging__field1">
              {tags.map((number, index) => (
                <div className="tags_input_item" key={index}>
                  <span className="text">{number}</span>
                  <span className="close" onClick={() => removeTag(index)}>
                    &times;
                  </span>
                </div>
              ))}
            </div>
          </Box>
          <Box
            gridColumn="span 3"
            backgroundColor={colors.primary[400]}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <TextField
              fullWidth
              variant="filled"
              type="text"
              label="Message"
              value={textInput}
              onChange={(e) => setTextInput(e.target.value)}
              multiline
              rows={5}
              name="message"
            />
          </Box>
        </Box>
        <Box display="flex" justifyContent="end" mt="20px">
          <Button
            type="submit"
            color="secondary"
            variant="contained"
            sx={{ cursor: "pointer" }}
            onClick={handlePost}
            startIcon={<SendOutlinedIcon style={{ fill: "#fff" }} />}
          >
            Send
          </Button>
        </Box>
        {/* {status && (
        <Snackbar
          snackbarRef={snackbarRef}
          messages={
            snackbarRef === "success" ? "message sent" : "message failed"
          }
          status={status}
          setStatus={setStatus}
        />
      )} */}
      </Paper>
    </Box>
  );
};

export default MultiSend;
